import $ from 'jquery';

let flashMessageTimeout;

export function flashMessage(message, kind = 'notice') {
  $('.flash').remove();
  const flash = document.querySelector('[data-admin-flash]');
  const level = kind === 'alert' ? 'error' : 'success';
  flash.dispatchEvent(new CustomEvent('flash:show', { detail: { message, level } }));

  clearTimeout(flashMessageTimeout);
  flashMessageTimeout = setTimeout(() => flash.dispatchEvent(new CustomEvent('flash:hide')), 5000);
}
